var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParametersShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8299)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8299",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8299)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8020_8299",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6998 4.5H4.69971V19.5H19.6998V4.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8020_8299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.80752 8.0175C5.65252 8.0175 4.70752 8.955 4.70752 10.1175C4.70752 11.2725 5.65252 12.2175 6.80752 12.2175C7.96252 12.2175 8.90752 11.2725 8.90752 10.1175C8.90752 8.955 7.97002 8.0175 6.80752 8.0175ZM6.80752 10.935C6.35752 10.935 5.99002 10.5675 5.99002 10.1175C5.99002 9.6675 6.35752 9.3 6.80752 9.3C7.25752 9.3 7.62502 9.6675 7.62502 10.1175C7.63252 10.5675 7.26502 10.935 6.80752 10.935ZM6.80752 7.5C7.20502 7.5 7.52752 7.1775 7.52752 6.78V5.2425C7.52752 4.845 7.20502 4.5225 6.80752 4.5225C6.41002 4.5225 6.08752 4.845 6.08752 5.2425V6.78C6.09502 7.1775 6.41752 7.5 6.80752 7.5ZM6.80752 12.75C6.41002 12.75 6.08752 13.0725 6.08752 13.47V18.78C6.08752 19.1775 6.41002 19.5 6.80752 19.5C7.20502 19.5 7.52752 19.1775 7.52752 18.78V13.47C7.52752 13.0725 7.20502 12.75 6.80752 12.75ZM12.2 9.945C11.045 9.945 10.1 10.8825 10.1 12.045C10.1 13.2 11.0375 14.145 12.2 14.145C13.355 14.145 14.3 13.2 14.3 12.045C14.3 10.89 13.355 9.945 12.2 9.945ZM12.2 12.8625C11.75 12.8625 11.3825 12.495 11.3825 12.045C11.3825 11.595 11.75 11.22 12.2 11.22C12.65 11.22 13.0175 11.5875 13.0175 12.0375C13.0175 12.4875 12.65 12.8625 12.2 12.8625ZM12.2 9.3975C12.5975 9.3975 12.92 9.075 12.92 8.6775V5.22C12.92 4.8225 12.5975 4.5 12.2 4.5C11.8025 4.5 11.48 4.8225 11.48 5.22V8.6775C11.48 9.075 11.8025 9.3975 12.2 9.3975ZM12.2 14.73C11.8025 14.73 11.48 15.0525 11.48 15.45V18.765C11.48 19.1625 11.8025 19.485 12.2 19.485C12.5975 19.485 12.92 19.1625 12.92 18.765V15.45C12.92 15.0525 12.5975 14.73 12.2 14.73ZM17.5925 11.775C16.4375 11.775 15.4925 12.72 15.4925 13.875C15.4925 15.03 16.4375 15.975 17.5925 15.975C18.7475 15.975 19.6925 15.0375 19.6925 13.875C19.685 12.72 18.7475 11.775 17.5925 11.775ZM17.5925 14.6925C17.1425 14.6925 16.775 14.325 16.775 13.875C16.775 13.425 17.1425 13.0575 17.5925 13.0575C18.0425 13.0575 18.41 13.425 18.41 13.875C18.41 14.325 18.0425 14.6925 17.5925 14.6925ZM17.5925 11.235C17.99 11.235 18.3125 10.9125 18.3125 10.515V5.22C18.3125 4.8225 17.99 4.5 17.5925 4.5C17.195 4.5 16.8725 4.8225 16.8725 5.22V10.515C16.8725 10.9125 17.195 11.235 17.5925 11.235ZM17.5925 16.5675C17.195 16.5675 16.8725 16.89 16.8725 17.2875V18.765C16.8725 19.1625 17.195 19.485 17.5925 19.485C17.99 19.485 18.3125 19.1625 18.3125 18.765V17.2875C18.305 16.8825 17.99 16.5675 17.5925 16.5675Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8299",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParametersShort);
export default __webpack_public_path__ + "static/media/Parameters-Short.5f7e8a228ad7031ea3043e012edd8f60.svg";
export { ForwardRef as ReactComponent };